import React from 'react';

function SidebarBrand() {
  return (
    <div className="mp-sidebar-brand">
      <img className="mp-sidebar-brand__logo-image mp-sidebar-brand__logo-image--dark" src="/logo-branca.png" alt="Marketing PRO" />
      <img className="mp-sidebar-brand__logo-image mp-sidebar-brand__logo-image--light" src="/logo-colorida.png" alt="Marketing PRO" />
    </div>
  );
}

export default SidebarBrand;
